module.exports = __webpack_public_path__ + "img/Arrow_Left_White.6ee32840.svg";